import { Controller } from 'stimulus';

class CookieConsent extends Controller {
  onAcceptCookies() {
    this.element.style.opacity = 0;
    this.element.style.visibility = 'hidden';

    CookieConsent.setCookie(this.data.get('name'), true, this.data.get('lifetime'));

    const tagManager = this.application.getControllerForElementAndIdentifier(document.documentElement, 'tag-manager');

    if (tagManager && typeof tagManager.onAcceptCookies === 'function') {
      tagManager.onAcceptCookies();
    }
  }

  static setCookie(name, value, minutes) {
    const date = new Date();
    date.setTime(date.getTime() + (minutes * 60 * 1000));
    const expires = `; expires=${date.toUTCString()}`;

    document.cookie = `${name}=${(value || '')}${expires}; path=/`;
  }
}

CookieConsent.targets = [
  //
];

export default CookieConsent;
